const GC = window.__GENERATED_CONSTANTS__

export const GROUP_NEW_OR_NOT_KNOWN = GC.GROUP_NEW_OR_NOT_KNOWN

export const TabKeys = {
    ACCOUNT_SETTINGS: 'accountSettings',
    PERMISSIONS: 'permissions'
}

export const ValidationErrors = {
    NO_SUCH_USER: "noSuchUser",
    NO_RIGHTS: "noRights",
    USER_IS_LOCKED: "userIsLocked",
    FIRST_NAME_EMPTY: "firstNameEmpty",
    LAST_NAME_EMPTY: "lastNameEmpty",
    EMAIL_WAS_EMPTY: "emailWasEmpty",
    EMAIL_EMPTY: "emailEmpty",
    PASSWORD_EMPTY: "passwordEmpty",
    PASSWORDS_DO_NOT_MATCH: "passwordsDoNotMatch",
    PASSWORD_COPY_EMPTY: "passwordCopyEmpty",
    PASSWORD_RESTRICTIONS_VIOLATED: "passwordError",
    OLD_PASSWORD_EMPTY: "oldPasswordEmpty",
    OLD_PASSWORD_INCORRECT: "oldPasswordIncorrect",
    USERNAME_EMPTY: "usernameEmpty",
    USERNAME_DUPLICATE: "duplicateUsername",
    NEW_USER_GROUP_EMPTY: "newUserGroupEmpty",
    NEW_TIME_ZONE_GROUP_EMPTY: "newTimeZoneGroupEmpty",
    DUPLICATE_TIME_ZONE_GROUP: "duplicateTimeZoneGroupError",
    CITY_DATA_EMPTY: "cityDataEmpty",
    HIRE_DATE_EMPTY: "hireDateEmpty",
    HIRE_DATE_IN_FUTURE: "hireDateInFuture",
    HIRE_DATE_IN_FUTURE_FOR_SELF: "hireDateInFutureForSelf",
    DUPLICATE_USERNAME: "duplicateUsername",
    LAST_MANAGER_IN_OTHER_PRODUCT: "lastManagerInOtherProduct",
    EMAIL_INVALID: "emailInvalid",
    ACTION_CONFIRMED: "confirmed",
    ACTION_NOT_CONFIRMED: "not_confirmed",
    DUPLICATED_EFFECTIVE_DATE: "duplicatedEffectiveDate",
    DISABLED_DUE_TO_LICENSE_TERMS: "disabledDueToLicenseTerms",
    USER_RATES_ERROR: 'userRatesError',
    WORK_SCHEDULE_ERROR: 'workScheduleError',
    LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE: 'LeavesOrTTBeforeNewHireDateException',
}

export const ValidationErrorsScrollClasses = {
    ACCOUNT_INFORMATION: 'accountInformationScrollPoint',
    TIME_TRACK_APPROVAL: 'timeTrackApprovalScrollPoint',
    WORK_SCHEDULE: 'workScheduleScrollPoint',
    USER_RATES: 'userRatesScrollPoint',
}

export const ValidationErrorsToScrollClasses = {
    [ValidationErrors.FIRST_NAME_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.LAST_NAME_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.EMAIL_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.EMAIL_INVALID]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.PASSWORD_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.PASSWORDS_DO_NOT_MATCH]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.PASSWORD_COPY_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.USERNAME_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.USERNAME_DUPLICATE]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.NEW_USER_GROUP_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.DUPLICATE_TIME_ZONE_GROUP]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.CITY_DATA_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.HIRE_DATE_EMPTY]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.HIRE_DATE_IN_FUTURE]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
    [ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF]: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,

    [ValidationErrors.WORK_SCHEDULE_ERROR]: ValidationErrorsScrollClasses.WORK_SCHEDULE,

    [ValidationErrors.USER_RATES_ERROR]: ValidationErrorsScrollClasses.USER_RATES,
}

export const ValidationErrorsScrollClassesPriority = {
    [ValidationErrorsScrollClasses.ACCOUNT_INFORMATION]: 4,
    [ValidationErrorsScrollClasses.TIME_TRACK_APPROVAL]: 3,
    [ValidationErrorsScrollClasses.WORK_SCHEDULE]: 2,
    [ValidationErrorsScrollClasses.USER_RATES]: 1,
}

export const UserTeamAssignmentType = {
    SELECTED: GC.UserTeamAssignmentType.SELECTED,
    ALL: GC.UserTeamAssignmentType.ALL,
    NO: GC.UserTeamAssignmentType.NO,
}



// WEBPACK FOOTER //
// ./web/js/panels/user/constants.js